import _ from 'lodash';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Popover, { PopoverAnimationVertical } from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';

import { updateVesselOrder, updateVesselOrderUser } from 'actions/vessels/orders';

const SelectedTextPopup = (props) => {
    const [numberVesselOrder, setNumberVesselOrder] = useState(null);

    const onChange = (e, fieldValue) => {
        if (numberVesselOrder === null) {
            return;
        }

        const newVesselOrder = _.cloneDeep(props.vesselOrders[numberVesselOrder]);
        const newUser = _.cloneDeep(props.vesselOrderUser);

        switch (fieldValue) {
        case 'term':
            newVesselOrder.terms.push({ type: '', value: props.chosenText });
            break;
        // todo check for autocomplete user
        case 'email':
            newUser.email = props.chosenText;
            break;
        case 'company':
            newUser.company = props.chosenText;
            break;
        case 'name':
            newUser.name = props.chosenText;
            break;
        case 'surname':
            newUser.surname = props.chosenText;
            break;
        case 'phonecode':
            newUser.phones[0].code = props.chosenText;
            break;
        case 'phone':
            newUser.phones[0].phone = props.chosenText;
            break;
        }

        props.updateVesselOrder(numberVesselOrder, newVesselOrder);
        props.updateVesselOrderUser(newUser);
        props.closePopover();
    };

    const selectVesselOrder = (_e, _index, value) => {
        setNumberVesselOrder(value);
    };

    let renderMenu = (
        <Menu onChange={onChange}>
            <MenuItem primaryText='Term' value='term' />
            <MenuItem primaryText='Email user' value='email' />
            <MenuItem primaryText='Company new user' value='company' />
            <MenuItem primaryText='Name new user' value='name' />
            <MenuItem primaryText='Surname new user' value='surname' />
            <MenuItem primaryText='Phone code new user' value='phonecode' />
            <MenuItem primaryText='Phone number new user' value='phone' />
        </Menu>
    );

    if (numberVesselOrder === null) {
        renderMenu = null;
    }

    return (
        <div className='popup'>
            <Popover
                open={props.openPopover}
                anchorEl={props.anchorEl}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                onRequestClose={props.closePopover}
                animation={PopoverAnimationVertical}
            >
                <div className='popup-choose'>
                    <div className='chosen'>
                        <div className='chosen-title'>
                            Chosen text
                        </div>
                        <div className='chosen-row'>
                            {`'${props.chosenText}'`}
                        </div>
                    </div>
                </div>
                <SelectField
                    floatingLabelText='Choose vessel order'
                    value={numberVesselOrder}
                    onChange={selectVesselOrder}
                    style={{
                        width: '200px',
                        padding: '0 10px',
                    }}
                >
                    {
                        props.vesselOrders.map((item, i) => (<MenuItem
                            key={i}
                            value={i}
                            primaryText={`Vessel order - ${i}`}
                        />))
                    }
                </SelectField>
                {renderMenu}
            </Popover>
        </div>
    );
};

export default connect(
    (state, ownProps) => ({
        openPopover: ownProps.openPopover,
        anchorEl: ownProps.anchorEl,
        closePopover: ownProps.closePopover,
        chosenText: ownProps.chosenText,
        vesselOrders: state.vesselOrders.items,
        vesselOrderUser: state.vesselOrders.user,
    }),
    dispatch => bindActionCreators({
        updateVesselOrder,
        updateVesselOrderUser,
    }, dispatch),
)(SelectedTextPopup);



// WEBPACK FOOTER //
// ./app/components/Letters/common/SelectedTextPopup.jsx